export const en = {
    confirmation_title: 'Delete an assistant',
    confirmation_description: 'Are you sure you want to delete the assistant for this user?',
};
